import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mime-select-container"
}

import { ref, inject, computed } from "vue";
import SelectButton from "primevue/selectbutton";
import { BeakerSession } from "beaker-kernel/src";
import { BeakerRenderOutput } from "../../renderers";


export default /*@__PURE__*/_defineComponent({
  __name: 'BeakerMimeBundle',
  props: [
    "mimeBundle",
    "collapse",
],
  setup(__props) {

const props = __props;

const session = inject<BeakerSession>('session');

const renderedBundle = computed<{[key: string]: BeakerRenderOutput}>(
    () => {
        return session.renderer.renderMimeBundle(props.mimeBundle) as any as {[key: string]: BeakerRenderOutput}
    }
);
const sortedMimetypes = computed(() => {return session.renderer.rankedMimetypesInBundle(props.mimeBundle)});

const selectedMimeType = ref<string>(sortedMimetypes.value[0]);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!(props.collapse && sortedMimetypes.value.length === 1))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(SelectButton), {
            allowEmpty: false,
            modelValue: selectedMimeType.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedMimeType).value = $event)),
            options: sortedMimetypes.value
          }, null, 8, ["modelValue", "options"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (renderedBundle.value[selectedMimeType.value]?.component)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(renderedBundle.value[selectedMimeType.value].component), _mergeProps({ key: 0 }, renderedBundle.value[selectedMimeType.value].bindMapping, {
            class: `rendered-output ${selectedMimeType.value.replace('/', '-')}`
          }), null, 16, ["class"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})